export { default } from "@peekops/peek-extensions-framework/services/extensions/portal";
